module.exports = __webpack_public_path__ + "static/img/hujiao2.d82fb37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/hujiao2.png
// module id = T8F/
// module chunks = 24